/**
 * Hook léger : nombre de fidèles en attente de validation + la liste.
 * Sert au badge Sidebar (Annuaire), au widget Dashboard et à l'onglet Annuaire.
 */
import { useCallback, useEffect, useState } from "react";
import { inscriptionsApi } from "../services/api";
import useAuth from "./useAuth";

export function useInscriptionsPending() {
  const { isAdmin, isAuthenticated, usingMock } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated || !isAdmin || usingMock) return;
    setLoading(true);
    try {
      const { data } = await inscriptionsApi.enAttente();
      setItems(data || []);
    } catch {
      // silencieux : ne pas casser la sidebar si l'endpoint échoue
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, isAdmin, usingMock]);

  useEffect(() => { refresh(); }, [refresh]);

  return { items, count: items.length, loading, refresh };
}

export default useInscriptionsPending;
